import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { SetPassword, ForgotPassword } from "@cti-workspace/helpers";
import cti3Logo from "../../assets/images/CTi3LoginLogo.png";
import { useSnackbar } from "notistack";
import PasswordField from "../../components/PasswordField";
import { Box } from "@cti-workspace/ui";
import { userStore } from "../../store/userStore";
import acn from "../../assets/images/acn.png";
import Style from "../login/login.style";
import { makeStyles } from "@material-ui/core/styles";

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

function checkPasswordStrength(password) {

  if (password === "") return "";

  let poolSize = 0;

  // Determine the size of the character pool
  if (/[a-z]/.test(password)) poolSize += 26; // Lowercase letters
  if (/[A-Z]/.test(password)) poolSize += 26; // Uppercase letters
  if (/[0-9]/.test(password)) poolSize += 10; // Digits
  if (/[\W_]/.test(password)) poolSize += 32; // Special characters
  if (/[\u0100-\uFFFF]/.test(password)) poolSize += 36; // Unicode characters (approx.)

  // Calculate entropy
  const entropy = Math.log2(poolSize) * password.length;

  // Classify strength based on entropy
  let strength = '';
  if (entropy < 28) strength = 'Very Weak';
  else if (entropy < 44) strength = 'Weak';
  else if (entropy < 64) strength = 'Average';
  else if (entropy < 128) strength = 'Strong';
  else strength = 'Very Strong';

  return strength;
}

const SetPasswordComponent = () => {
	let token = useQuery().get("token");
	// console.log(token);
	let navigate = useNavigate();

	let uri = document.documentURI;
	let urlValue = new URL(uri);
	let whiteLabelID = urlValue.hostname.split(".")[1];

	const [password, setPassword] = useState("");
	const [confirm, setConfirm] = useState("");
	const [email, setEmail] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [passwordMatchError, setPasswordMatchError] = useState("");
	const [resendPwdSuccessMsg, setResendPwdSuccessMsg] = useState("");
  const [complexity, setComplexity] = useState("");
	const { enqueueSnackbar } = useSnackbar();

  const setIsLoggedIn = userStore((state) => state.userLogIn);

  const useStyles = makeStyles(Style);
  const classes = useStyles();

	// TODO: remember to log out user

	// useEffect(() => {
	// 	(async function iife() {
	// 		await setUserLogout();
	// 	})();
	// }, []);

	const handleSubmit = async () => {
		try {
      if (password === confirm && password !== "") {
        if (complexity.includes("eak") === true) {
          setPasswordMatchError("Password is too weak");
          return;
        }
				let res = await SetPassword(password, token);
				const loginData = await setIsLoggedIn({ email: "", password: "", organization: "" }, res);
				if (res)
					enqueueSnackbar("Set Password Success", {
						variant: "success",
					});
				let { from } = { from: { pathname: "/" } };
				if (loginData) {
					let { dbAccount } = loginData;
					if (dbAccount && dbAccount.roles.length === 1 && dbAccount.roles.includes("holder")) {
						enqueueSnackbar("Login Success", { variant: "success" });
						navigate("/wallet", { replace: true });
					} else {
						if (dbAccount?.organizations?.default) {
							enqueueSnackbar("Login Success", { variant: "success" });
						}
						navigate(from, { replace: true });
					}
				} else {
					enqueueSnackbar("Login failed", { variant: "error" });
				}
			} else {
				setPasswordMatchError("Passwords do not match");
			}
		} catch (error) {
      console.error(error);
      if (error.message.includes("Document not found")) {
        setErrorMessage("The password reset link is no longer valid");
      }
      else {
        setErrorMessage(error.message);
      }
		}
	};

	const handleResendPassword = async () => {
		try {
			if (email) {
				let val = await ForgotPassword(email);
				if (val) {
					enqueueSnackbar(`Password Reset Success `, {
						variant: "success",
					});
					setResendPwdSuccessMsg("Reset link sent. Check your email");
					setErrorMessage("");
				}
			} else {
				console.error("Email is required");
			}
		} catch (error) {
			console.error(error);
			setErrorMessage(error.message);
		}
  };

  function SetComplexityValue( password ) {
    let complexity = checkPasswordStrength(password);
    setComplexity(complexity);
  }

  return (
    <div className={classes.center} style={{ maxWidth: "800px" }} >
      <Grid container spacing={2} direction="column" alignItems="center" style={{paddingTop: "5%"}}>
        <Grid item lg={3} style={{ maxWidth: "90%" }}>
				{errorMessage && (
					<Alert severity="error">
						<Typography variant="h6">{errorMessage}</Typography>
					</Alert>
				)}
          {!errorMessage && passwordMatchError && (
            <Alert severity="error">
						<Typography variant="h6">{passwordMatchError}</Typography>
					</Alert>
        )}
      </Grid>
        <Grid container spacing={2}>
          <Grid container item xs={12} sm={6} display="flex" alignItems="center" height="500px" style={{ alignItems: "center", display: "flex", justifyContent: "center", padding: "0px" }} >
				<Box mx="auto" p={1}>
					<Box display="flex" flexDirection="column" mx="auto" alignItems="center" justifyContent="center" p={1}>
						<img
							style={{
								paddingTop: 2,
								paddingBottom: 2,
								width: 372,
							}}
							src={whiteLabelID === "acn" ? acn : cti3Logo}
							alt="CTi3"
						/>
					</Box>
          </Box>
       </Grid>
       <Grid container item xs={12} sm={6} display="flex" justifyContent="center" alignItems="center" height="500px">
          <Box mx="auto" p={1}>
            {!errorMessage && !resendPwdSuccessMsg ? (
              whiteLabelID === "acn" ? (
                <Typography style={{ color: "#004E78" }} variant="h6">
                  Set New Password
                </Typography>
              ) : (
                <Typography color="secondary" variant="h6">
                  Set New Password
                </Typography>
              )
              ) : !resendPwdSuccessMsg ? (
                  <Typography color="secondary" variant="h6">
                    Resend Password Reset Link
                  </Typography>
           ) : null}
            <hr style={{ width: "100%" }} />

					{!errorMessage && !resendPwdSuccessMsg ? (
						<Box mx="auto" p={1}>
							<PasswordField
								id="outlined-adornment-setpassword"
								handleChange={(event) => {
                  SetComplexityValue(event.target.value); setPassword(event.target.value);
								}}
								label={"New Password"}
								placeholder={"9djsk$827s0sj"}
								required
								labelWidth={105}
							/>
							<PasswordField
								id="outlined-adornment-confirmpassword"
								handleChange={(event) => {
									setConfirm(event.target.value);
								}}
								label={"Confirm Password"}
								placeholder={"9djsk$827s0sj"}
								required
								labelWidth={130}
                  />
                  <Typography style={{ color: (complexity.includes("eak") ? "#780000" : (complexity.includes("verage") ? "#707000" : "#007800")), marginTop: (complexity === "" ? "14px" : "-10px") }} variant="body1">{complexity}</Typography>                 
							{whiteLabelID === "acn" ? (
								<Button variant="contained" style={{ backgroundColor: "#004E78", borderColor: "#004E78", color: "white" }} id="setPassword" type="submit" fullWidth={true} onClick={handleSubmit}>
									Set Password
								</Button>
							) : (
								<Button variant="contained" color="primary" id="setPassword" type="submit" fullWidth={true} onClick={handleSubmit}>
									Set Password
								</Button>
                  )}
						</Box>
					) : !resendPwdSuccessMsg ? (
						<Box mx="auto" p={1}>
							<TextField required fullWidth={true} id="resend-email" label="Email" placeholder={"your.name@gmail.com"} margin="normal" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
							<Button variant="contained" color="primary" id="resendPassword" type="submit" fullWidth={true} onClick={handleResendPassword}>
								Resend Password
							</Button>
						</Box>
					) : (
              <><Box mx="auto" p={1}>
							<Alert severity="success">
								<Typography variant="h6">{resendPwdSuccessMsg}</Typography>
							</Alert>
						</Box>
            <hr style={{ width: "100%" }} /></>
					)}
				</Box>
			</Grid>
		</Grid>
    </Grid>
    </div>
	);
};

export default SetPasswordComponent;
